import * as THREE from 'three';
import { buildSD150 } from './rails';
import { makeMT150 } from './mt150';
import { makeFixedWindow } from './fixedWindows';
import { makeBifoldDoor } from './bifold';
import { makeSwingDoor } from './swing';
import { makePivotDoor } from './pivot';

export const FINISHES = { graphite: '#3c4245', bronze: '#88715a', silver: '#bac2c4' };
export const box = (parent, w, h, d, x, y, z, material) => {
  const mesh = new THREE.Mesh(new THREE.BoxGeometry(w, h, d), material);
  mesh.position.set(x, y, z); mesh.castShadow = true; mesh.receiveShadow = true;
  parent.add(mesh); return mesh;
};

export function makeProduct(p, materials) {
  if (p.is_fixed) return makeFixedWindow(p,materials);
  if (p.kind === 'bifold') return makeBifoldDoor(p, materials);
  if (p.kind === 'swing') return makeSwingDoor(p, materials);
  if (p.kind === 'pivot') return makePivotDoor(p, materials);
  if (p.family === 'MT150') return makeMT150(p, materials);
  if (p.id !== 'sd-150') throw new Error(`Unsupported showroom product: ${p.id}`);
  const group = new THREE.Group();
  const frame = materials.makeFrame();
  const animate = buildSD150(group, p, frame, materials.glass, materials.steel, materials);
  animate(0);
  group.traverse(o => { if (o.isMesh) o.userData.productId = p.id; });
  return { group, frame, animate, progress: 0, raised: 0 };
}

export function textTexture(text, { color = '#e8ece9', size = 90, width = 1024, height = 256, font = '500' } = {}) {
  const canvas = document.createElement('canvas'); canvas.width = width; canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = color; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.font = `${font} ${size}px "Raleway", sans-serif`;
  ctx.fillText(text, width / 2, height / 2);
  const texture = new THREE.CanvasTexture(canvas); texture.colorSpace = THREE.SRGBColorSpace;
  return texture;
}

export function label(text, width, height, opts) {
  return new THREE.Mesh(new THREE.PlaneGeometry(width, height), new THREE.MeshBasicMaterial({ map: textTexture(text, opts), transparent: true, depthWrite: false, side: THREE.DoubleSide }));
}